// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var InvoiceDetailsController = function ($scope, $routeParams, Invoice, InvoiceDownload, $http, PUtill, Contract,
    EInvoicingDispatchStatusDisplayService, DatepickerUtils) {
    Invoice.get({ invoiceId: $routeParams.invoiceId }, function (invoice) {
        angular.forEach(invoice.ItemList, function (value) {
            let localStartDate = new Date(value.PeriodStart);
            let localEndDate = new Date(value.PeriodEnd);
            let period = correctPeriod(localStartDate, localEndDate);
            value.PeriodStartLocal = correctDateStart(period.start);
            value.PeriodEndLocal = correctDateEnd(period.start, period.end);
            value.ShowEndDate = value.PeriodStartLocal !== value.PeriodEndLocal;
        });

        $scope.invoice = invoice;
        $scope.sign = invoice.IsInvoice ? +1 : -1;

        $scope.dispatchStatusClass = EInvoicingDispatchStatusDisplayService.dispatchStatusClass(invoice);

        $scope.dispatchStatusLabel = EInvoicingDispatchStatusDisplayService.dispatchStatusLabel(invoice);

        $scope.dispatchStatusLastPolledAt = EInvoicingDispatchStatusDisplayService.getLastPollingDate(invoice);

        Contract.get({ contractId: invoice.ContractId }, function (contract) {
            $scope.canBeCorrected = !contract.CustomerIsLocked && !contract.WriteOff;
        });
    });

    $http({
        method: "GET",
        url: "/api/v1/legalEntity/isExtendedLineItemInformation",
        params: null,
        data: null,
        headers: {},
        cache: false
    }).then(function (response) {
        $scope.showExtendedBookedQuantityInformation = response.data;
    });

    function getLocaleConversionParameters() {
        return {
            options: {
                hour12: false,
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: PUtill.BerlinTzName
            },
            locale: "de-DE"
        }
    }

    function correctPeriod(localStart, localEnd) {
        let result = {
            start: localStart,
            end: localEnd
        }

        if (localEnd != null && (localStart == null || localStart > localEnd)) {
            result.start = localEnd;
            result.end = localStart;
        }

        return result;
    }

    function correctDateStart(localStart) {
        let params = getLocaleConversionParameters();
        let result = localStart;

        if (localStart != null) {
            result = localStart.toLocaleString(params.locale, params.options);
        }

        return result;
    }

    function correctDateEnd(localStart, localEnd) {
        const offset = 1000;
        let params = getLocaleConversionParameters();
        let result = localEnd;

        if (localStart != null && localEnd != null) {

            let startTime = localStart.getTime();
            let endTime = localEnd.getTime();

            if (PUtill.isTimeZero(localEnd)) {
                endTime -= offset;
            }

            let maxTime = Math.max(startTime, endTime);
            result = new Date(maxTime).toLocaleString(params.locale, params.options);
        }

        return result;
    }

    $scope.download = function (id) {
        var downloadInfo = new InvoiceDownload();
        downloadInfo.$save({ invoiceId: id }, function () {
            window.location = downloadInfo.Url;
        });
    };
    
    $scope.backHistory = function () {
        window.history.back();
    }
};
InvoiceDetailsController.$inject = ['$scope', '$routeParams', 'Invoice', 'InvoiceDownload', '$http', 'PUtill',
    'Contract', 'EInvoicingDispatchStatusDisplayService', 'DatepickerUtils'];
